module.exports = __webpack_public_path__ + "img/no-image.4794a642.png";